/* eslint-disable promise/always-return */
import { restrictions as config } from '@config';
import { debounce } from 'src/utils/toolbelt';

import { instance as CompanyFactory } from '../../../factory/company';
import RestrictionsFactory from '../../../factory/restrictions';
import WorkflowFactory from '../../../factory/workflow';

const template = require('./template-restrictions.hbs');

module.exports = Backbone.mixin(Backbone.View.extend({
  events: {
    'click dt > a': 'categoryToggleEvent',
    'click dt ul.sublist a.sub-category': 'subCategoryToggleEvent',
    'change input': 'changePermissionEvent',
    'click div.request-action-toggle': 'toggleOptionEvent',
    'click div.selected-approval': 'toggleApprovalListEvent'
  },

  toggleOptionEvent: function (event) {
    const target = event.currentTarget;
    const permissionName = target.parentElement.getAttribute('name');
    const requestInput = document.querySelector(`input.request-option[name=${permissionName}]`);
    const basicInput = requestInput.parentElement.querySelector('.basic-option');
    const key = target.getAttribute('name');

    target.parentElement.querySelectorAll('.request-action-toggle').forEach(option => {
      option.classList.remove('selected-approval-option');
    });

    target.classList.add('selected-approval-option');
    toggleOption(key);

    function toggleOption (option) {
      switch (option) {
        case 'restricted':
          basicInput.checked = false;
          requestInput.checked = false;
          break;

        case 'under_request':
          basicInput.checked = false;
          requestInput.checked = true;
          break;

        case 'permited':
          basicInput.checked = true;
          requestInput.checked = false;
          break;
      }
      const event = new Event('change', { bubbles: true });

      basicInput.dispatchEvent(event);
      requestInput.dispatchEvent(event);
    }
  },

  categoryToggleEvent: function (event) {
    const $button = $(event.currentTarget);
    const $container = $button.closest('dt');
    const isActive = $container.hasClass('active');

    isActive ? collapseList($container) : uncollapseList();
    this.trigger('update');

    function collapseList ($container) {
      $container.removeClass('active').removeAttr('style');
      $button.find('icon.chevron').css('transform', 'rotate(180deg)');
    }

    function uncollapseList () {
      let height = 0;

      $container.contents().each(function () {
        if (this.nodeType === 1) {
          height += $(this).outerHeight(true);
        }
      });

      $container.addClass('active').height(height);
      $button.find('icon.chevron:not(.select-approval-icon)').css('transform', 'rotate(90deg)');
    }
  },

  subCategoryToggleEvent: function (event) {
    const button = event.currentTarget;
    const container = button.closest('dt');
    const subList = button.nextElementSibling;
    const isActive = subList.classList.contains('active');

    isActive ? collapseList() : uncollapseList();

    function collapseList () {
      container.style.height = `${container.offsetHeight - subList.offsetHeight}px`;
      setTimeout(() => subList.classList.remove('active'), 500);
      subList.style.height = '';
      button.querySelector('icon.chevron').style.transform = 'rotate(180deg)';
    }

    function uncollapseList () {
      let totalHeight = 0;

      Array.from(subList.getElementsByTagName('li')).forEach((li) => {
        totalHeight += li.offsetHeight;
      });

      subList.classList.add('active');
      subList.style.height = `${totalHeight}px`;
      container.style.height = `${container.offsetHeight + totalHeight}px`;
      button.querySelector('icon.chevron:not(.select-approval-icon)').style.transform = 'rotate(90deg)';
    }
  },

  recalculateSectionHeight: function (target) {
    const container = target.closest('dt');
    const isSubCategory = !!target.closest('ul.sublist');

    if (!container) return;

    let height = config.sectionInitialHeight;
    const list = container.querySelectorAll('dt > a, dt > ul');

    list.forEach(function (node) {
      if (node.nodeType === 1 && !node.classList.contains('hidden')) {
        height += node.getBoundingClientRect().height;
      }
    });

    container.classList.add('active');
    container.style.height = `${Math.round(height) + (isSubCategory ? 0 : config.templateRestrictionsContainerMargin)}px`;
  },

  toggleApprovalListEvent: function (event) {
    const target = event.currentTarget.closest('div.selected-approval');
    const tabName = target.getAttribute('name');
    const tabs = ['function_request_download_file', 'function_request_print_file', 'function_request_share_file'];
    const approvalDropdown = this.el.querySelector('ul[name="' + tabName + '"]');
    const selectApprovalIcon = target.querySelector('.select-approval-icon');

    tabs
      .filter(tab => tab !== tabName)
      .forEach((tab) => {
        const otherApprovalDropdown = this.el.querySelector('ul[name="' + tab + '"]');
        const otherSelectApprovalIcon = this.el.querySelector('div[name="' + tab + '"] .select-approval-icon');
        otherApprovalDropdown.style.visibility = 'hidden';
        otherSelectApprovalIcon.style.transform = 'rotate(270deg)';
      });

    if (approvalDropdown.style.visibility === 'visible') {
      selectApprovalIcon.style.transform = 'rotate(270deg)';
      approvalDropdown.style.visibility = 'hidden';
    } else {
      selectApprovalIcon.style.transform = 'rotate(90deg)';
      approvalDropdown.style.visibility = 'visible';
    }
  },

  savePermission: function () {
    RestrictionsFactory.save(true);
  },

  changePermissionEvent: function (event) {
    const input = event.currentTarget;
    const name = input.getAttribute('name');
    const isChecked = input.checked;

    // eslint-disable-next-line promise/catch-or-return
    RestrictionsFactory.setGlobalTemplateRestriction(name, isChecked).then(() => {
      // If user click simplified restrictions option, we don't need to auto save
      // because a popup modal will be shown to ask user to confirm
      if (name !== 'simplified-template-restrictions-option') {
        this.savePermission();
      }
    });
    this.recalculateSectionHeight(event.currentTarget);
  },

  initialize: function () {
    $.when(
      CompanyFactory.get(['templates', INKIVE.C.BOOK.encodedId]),
      CompanyFactory.get(['groups'])
    ).then(_.bind(this.processGroups, this));
  },

  processGroups: function (template, groups) {
    this.categories = [];
    this.groups = groups;

    const someGroup = _(this.groups).find(function (group) {
      return group.permissions && group.permissions.template;
    });

    if (someGroup) {
      this.permissionsList = _(someGroup.permissions.template)
        .map(function (p, index) { return { name: index, tag: 'tool.restrictions.template.permission.' + index }; })
        .filter(function (field) { return ['logo_colour', 'logo_stroke', 'function_edit_animation_file', 'function_draw'].indexOf(field.name) < 0; });

      this.categories.push({
        title: 'tool.restrictions.title.settings',
        permissions: []
      });

      this.categories.push({
        key: 'usage',
        tag: 'tool.restrictions.template.categories.usage',
        permissions: (() => {
          const order = ['function_download_file', 'function_print_file', 'function_share_file', 'function_animation_file', 'function_change_layer_order'];
          const permission = this.getSpecificPermissions(/^function_.*_file$|function_change_layer_order/);

          return order.map(name => permission.find(p => p.name === name)).filter(p => p);
        })(),
        icon: 'edit---3'
      });

      this.categories.push({
        key: 'web_content',
        tag: 'tool.restrictions.template.categories.web_content',
        permissions: this.getOrderedSpecificPermissions(
          /function_use_desygner_background|function_use_own_images|function_use_desygner_vector|function_use_web_images|function_use_desygner_font/
        ),
        icon: 'briefcase'
      });

      this.categories.push({
        key: 'pages',
        tag: 'tool.restrictions.template.categories.pages',
        permissions: this.getSpecificPermissions(
          /function_add_page|function_change_page_order/
        ),
        icon: 'document'
      });

      this.categories.push({
        title: 'tool.restrictions.title.permissions',
        permissions: []
      });

      ['text', 'image', 'logo', 'vector', 'icon', 'video', 'qrcode', 'table'].forEach((key) => {
        const permissionsByType = this.getSpecificPermissions(new RegExp('^' + key + '_(?!add).*'))
          .filter(({ name }) => !name.endsWith('z_index'));
        // TODO: Move this out of here
        let permissions;
        switch (key) {
          case 'qrcode':
            permissions = permissionsByType.filter(
              ({ name }) => !['qrcode_replace'].includes(name)
            );
            break;
          case 'vector':
            permissions = permissionsByType.filter(
              ({ name }) => !['vector_replace'].includes(name)
            );
            break;
          case 'video':
            permissions = permissionsByType.filter(
              ({ name }) => !['video_flags'].includes(name)
            );
            break;
          default:
            permissions = permissionsByType;
            break;
        }

        this.categories.push({
          key,
          tag: 'tool.restrictions.template.categories.' + key,
          icon: this.getIcon(key),
          groupedPermissions: this.groupPermissions(key, permissions)
        });
      }, this);
    }

    this.addPermissionsSeparator();
    this.render();
  },

  getIcon (key) {
    switch (key) {
      case 'text':
        return 'text---nunito';
      case 'table':
        return 'table---20';
      case 'image':
        return 'image---content---32';
      case 'vector':
        return 'geometrical-shapes---20';
      case 'logo':
        return 'copyright';
      case 'icon':
        return 'editor-elements';
      case 'video':
        return 'video-camera';
      case 'qrcode':
        return 'qr-code';
    }
  },

  getSpecificPermissions: function (regex) {
    return this.permissionsList.filter(function (field) { return field.name.match(regex); });
  },

  getOrderedSpecificPermissions (regex) {
    const permissions = this.getSpecificPermissions(regex);
    const orderArray = regex.source.split('|');

    return permissions.sort((a, b) => {
      return orderArray.indexOf(a.name) - orderArray.indexOf(b.name);
    });
  },

  render: function () {
    WorkflowFactory.isEnabled().then(
      _.bind(this._render, this, true),
      _.bind(this._render, this, false)
    );
  },

  _render: function (hasWorkflow) {
    hasWorkflow && this.categories.find((c) => c.key === 'usage').permissions.forEach((p) => {
      if (!p.name.includes('animation') && !p.name.includes('layer_order')) {
        p.request_name = p.name.replace('function_', 'function_request_');
      }
    });

    this.$el.html(template({
      settings: this.categories.filter(c => c.settings),
      categories: this.categories.filter(c => !c.settings),
      approvalDropdownItems: config.approvalDropdownItems
    }));

    this.renderRestrictions();
    this.trigger('update');
  },

  renderRestrictions: function () {
    const deferred = $.Deferred();

    RestrictionsFactory.getTemplatePermissions().then(_.bind(function (permissions) {
      permissions = _(permissions).find(function (p) { return !p.group; });

      _.each(permissions, function (value, key) {
        this.$el.find('input[name="' + key + '"]').prop('checked', value);
        const animationElement = document.querySelector('input[name=function_animation_file]');
        const animationOption = animationElement?.parentElement?.parentElement;

        if (!INKIVE.C.SHOW_ANIMATION) {
          if (animationOption) animationOption.classList.add('hidden');
        }
      }, this);

      this._checkRestrictionType(permissions);
      this.setSelectedApproval();

      deferred.resolve();
    }, this));

    return deferred.promise();
  },

  _checkRestrictionType: function (permissions) {
    const isRestrictionTypes = [];

    _.each(config.restrictionTypes, function (value) {
      const defaults = RestrictionsFactory.getDefaultsByType(value);
      const permissionInput = document.querySelector('input[data-type="' + value + '"]');
      let same = true;

      for (const restriction in permissions) {
        if (!(restriction in defaults)) continue;

        if (permissions[restriction] === defaults[restriction]) continue;

        same = false;
        break;
      }

      if (permissionInput) permissionInput.checked = same;
      isRestrictionTypes.push(same);
    });
  },

  setSelectedApproval: function () {
    this.categories.find((c) => c.key === 'usage').permissions.forEach((p) => {
      const basicInput = document.querySelector('input[name="' + p.name + '"]');
      const requestInput = document.querySelector('input[name="' + p.request_name + '"]');
      const selectedApproval = document.querySelector('div[name="' + p.request_name + '"]');

      if (selectedApproval) {
        selectedApproval.querySelector('[name=permited]')?.classList.remove('selected-approval-option');
        selectedApproval.querySelector('[name=under_request]')?.classList.remove('selected-approval-option');
        selectedApproval.querySelector('[name=restricted]')?.classList.remove('selected-approval-option');
      }

      if (requestInput && selectedApproval) {
        if (basicInput.checked && !requestInput.checked) {
          selectedApproval.querySelector('[name=permited]').classList.add('selected-approval-option');
        } else if (requestInput.checked) {
          selectedApproval.querySelector('[name=under_request]').classList.add('selected-approval-option');
        } else if (!basicInput.checked && !requestInput.checked) {
          selectedApproval.querySelector('[name=restricted]').classList.add('selected-approval-option');
        }
      }
    });
  },

  groupPermissions: function (key, permissions) {
    const groupedPermissions = { control: [], edit: [] };
    const addPermission = this.getSpecificPermissions(`${key}_add`);

    addPermission && addPermission.length && groupedPermissions.control.push(addPermission[0]);
    permissions.forEach(permission => {
      const type = permission.name.replace(`${key}_`, '');

      if (['duplication', 'deletion', 'rotation', 'position', 'z_index'].includes(type)) {
        groupedPermissions.control.push(permission);
      } else {
        groupedPermissions.edit.push(permission);
      }
    });

    groupedPermissions.control = this.sortPermissions(key, groupedPermissions.control);
    groupedPermissions.edit = this.sortPermissions(key, groupedPermissions.edit);

    return groupedPermissions;
  },

  sortPermissions: function (key, permissions) {
    const order = ['add', 'position', 'rotation', 'duplication', 'deletion', 'content', 'change_content',
      'edit', 'row_column', 'merge_split', 'text_color', 'text_style', 'object_color',
      'replace', 'crop', 'resize', 'size', 'colour', 'highlight', 'filter', 'opacity', 'alignment', 'spacing', 'font_family',
      'font_size', 'decoration'];

    return permissions.sort((a, b) => {
      const indexA = order.findIndex(keyword => a.name === `${key}_${keyword}`);
      const indexB = order.findIndex(keyword => b.name === `${key}_${keyword}`);

      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });
  },

  addPermissionsSeparator: function () {
    const hasSeparator = ['function_animation_file', 'text_alignment'];
    const addSeparator = permissions => {
      permissions.forEach(permission => {
        permission.separator = hasSeparator.includes(permission.name);
      });
    };

    this.categories.forEach(category => {
      category.permissions && addSeparator(category.permissions);
      category.groupedPermissions && addSeparator(category.groupedPermissions.edit);
    });
  }
}), Backbone.Events);
